import React from "react";
import { DatePickerField } from "@td/ui";
import { translate } from "@td/shared_utils";
import { fieldTypes } from "../constants";

const DueDateField = React.memo(() => (
  <DatePickerField
    name={fieldTypes.DUE_DATE}
    dateFormat="MM/dd/yyyy"
    className="due-date-field"
    label={translate(null, "care_team_tasks.form.fields.due_date", "label")}
    placeholderText={translate(null, "care_team_tasks.form.fields.due_date", "placeholder")}
  />
));

export default DueDateField;
